import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';
import TAG_TYPES from 'api/tags/TAG_TYPES';
import { PIPELINE_TAGS_QUERY } from 'api/pipeline-tags/useQueryPipelineTags';
import { PIPELINES_QUERY } from 'api/pipelines/pipelines-query-builder';
import { TAGS_QUERY } from 'api/tags/useQueryTags';

import {
  mutation as addTagToPipelineMutation,
  buildVariables as buildInsertVariables,
} from './add-tag-to-pipeline-mutation-builder';

export default function useAddTagToPipeline(options = {}) {
  const [executeMutation] = useMutation(addTagToPipelineMutation, {
    context: { permission: permissions.writeTags },
    refetchQueries: [PIPELINE_TAGS_QUERY, PIPELINES_QUERY, TAGS_QUERY],
    ...options,
  });

  const addTagToPipeline = ({ pipelineId, label }) => {
    return executeMutation(buildVariables({ pipelineId, label }));
  };

  return [addTagToPipeline];
}

function buildVariables({ pipelineId, label }) {
  return {
    variables: buildInsertVariables({ pipelineId, label, type: TAG_TYPES.PIPELINE }),
  };
}
